import moment from "moment";
import Vue from 'vue';
import { router } from '@/router';
import _ from 'lodash';
import store from '@/store';


function initialState() {
    return {
        AdvanceSalesReportExcelFileName: null,
        AdvanceSalesReportPDFFileName: null,
        dropDownObject: {
            fromDate: new Date(),
            cinema_name: null,
            cinema_id: null,
            movie_id: null,
            movie_title: null,
        },
        AdvanceSalesReport: [],
        pdfrecord: '',
        excelrecord: ''
    }
}

const state = initialState();

const mutations = {
    SET_DROP_DOWN_VALUES: (state, payload) => {
        switch (payload.name) {
            case 'isCinema':
                state.dropDownObject.cinema_id = payload['selectedItem'] ? payload.selectedItem.cine_id : null;
                state.dropDownObject.cinema_name = payload['selectedItem'] ? payload.selectedItem.cine_name : null;
                break;
            case 'MasterMovie':
                state.dropDownObject.movie_id = payload['selectedItem'] ? payload.selectedItem.movie_id : null;
                state.dropDownObject.movie_title = payload['selectedItem'] ? payload.selectedItem.movie_title : null;
                break;
            default: console.log('Advance Sales Report :( Sorry, we are enable to set value.');
        }
    },

}

const actions = {
    onAdvanceSalesReportDropDownHandler: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_DROP_DOWN_VALUES', payload);
    },




}

const getters = {
    getAdvanceSalesReportsSelectedCinema: state => state.dropDownObject.cinema_name,
    getAdvanceSalesReportsSelectedMovie: state => state.dropDownObject.movie_title,
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/AdvanceSalesReport.js